import { NgModule } from "@angular/core";
import { NumbersOnlyDirective } from "./numbers-only.directive";

@NgModule({
    imports: [],
    declarations: [NumbersOnlyDirective],
    exports: [NumbersOnlyDirective]
})
export class DirectivesModule { }